import { makeHttpRequest } from "@/shared";

import { mapCalculatedSellingFromServer } from "./mappers/mapCalculatedSellingFromServer";
import { mapSellingProductToServer } from "./mappers/mapSellingProductToServer";

export const addProductToSelling = async (sessionKey, product) => {
    const response = (
        await makeHttpRequest({
            url: `/stock/builder/${sessionKey}/add/product`,
            method: "PUT",
            data: mapSellingProductToServer(product),
        })
    ).data;

    return mapCalculatedSellingFromServer(response.data);
};
